import React, { Component } from 'react';
import Main from '../layout/Main';

import './style.css';

class App extends Component {
  render() {
    return (
      <div className="app">
        <Main />
      </div>
    );
  }
}

export default App;
